module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[96]339.5ce5dd8.woff2";